import { useTranslation } from 'react-i18next';
import { DownloadOutlined, DownOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Col, Row, TableColumnType, Typography } from "antd";
import React, { ChangeEvent, FunctionComponent, KeyboardEvent } from "react";
import FormInput from "../../../../components/form-input/FormInput";

type FilterTableProps = {
  tab: string;
  searchValue: string;
  onExport?: () => void;
  handleOpenFilter: () => void;
  handleSubmitSearch: () => void;
  handleSearch: (e: KeyboardEvent<HTMLSpanElement>) => void;
  handleChangeInput: (e: ChangeEvent<HTMLInputElement>) => void;
};

const FilterStudentList: FunctionComponent<FilterTableProps> = ({
  searchValue,
  onExport,
  handleSearch,
  handleOpenFilter,
  handleChangeInput,
  handleSubmitSearch,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Row
        gutter={[{ md: 8, xl: 8, xs: 8 }, 8]}
        className="flex justify-end flex-no-wrap"
      >
        <Col
          className="filter-group-select"
        >
          <div className="heading-filter">
            <Button className="filter-button" onClick={handleOpenFilter}>
              <Typography.Text>{t("Bộ lọc", "Bộ lọc")}</Typography.Text>
              <DownOutlined />
            </Button>
          </div>
        </Col>
        <Col
        >
          <div className="heading-search">
            <FormInput
              placeholder={t("Nhập tên học viên", "Nhập tên học viên")}
              value={searchValue}
              onChange={handleChangeInput}
              onKeyPress={handleSearch}
              afterPrefixIcon={<SearchOutlined onClick={handleSubmitSearch} />}
            />
          </div>
        </Col>
        <Col>
          <div className="heading-filter">
            <Button
              className="btn btn-primary clear-filter-btn"
              onClick={onExport}
            >
              <DownloadOutlined />
              <Typography.Text>{t("Xuất file", "Xuất file")}</Typography.Text>
            </Button>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default FilterStudentList;
